export default "__VITE_ASSET__DLHjKO7i__"